import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import { useAuth } from "./AuthContext";
import { useIsAuthenticated as useMsalAuthenticated } from "@azure/msal-react";

// Pages
import Login from "./pages/login/login";
import DashboardPage from "./pages/dashboard/dashboard";
import ClientItem from "./pages/client-item/client-item";
import ClientList from "./pages/client-list/client-list";
import ArticlesPage from "./pages/article-list/article-list";
import UserList from "./pages/Users/Users";
import Industries from "./pages/industries/industries";
import Publications from "./pages/publications/publications";

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  const msalAuthed = useMsalAuthenticated();
  const allowed = isAuthenticated || msalAuthed;
  if (!allowed) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/client/:id" element={<ProtectedRoute><ClientItem /></ProtectedRoute>} />
        <Route path="/clients" element={<ProtectedRoute><ClientList /></ProtectedRoute>} />
        <Route path="/articles" element={<ProtectedRoute><ArticlesPage /></ProtectedRoute>} />
        <Route path="/settings/users" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
        <Route path="/settings/industries" element={<ProtectedRoute><Industries /></ProtectedRoute>} />
        <Route path="/publications" element={<ProtectedRoute><Publications /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
